import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import SearchFields from './fields'
import Map from '_/shared/components/map'
import MapSidebar from '_/shared/components/mapSidebar'

/**
 * Map search page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MapSearch extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    metro: React.PropTypes.object.isRequired,
    query: React.PropTypes.object,
    savedSearches: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  static fetchData (store, { params }) {
    return {
      metro: store.get('/account/metro'),
      savedSearches: store.get('/searches')
    }
  }

  constructor(props, context) {
    super(props, context)

    const { store } = context

    if (!props.query.refine) {
      delete store.storage.lastSearch
    }

    delete store.storage.searchIds
    delete store.storage.lastSearchResult
    store.delete('~/search/lastResult')

    this.state = {
      geometry: store.storage.lastSearch
        ? JSON.parse(store.storage.lastSearch).geometry
        : undefined
    }
  }

  handleSavedSearch (search) {
    const hasGeometry = search.hasIn(['criteria', 'geometry'])

    this.setState({
      geometry: hasGeometry
        ? search.getIn(['criteria', 'geometry']).toJS()
        : undefined
    })
  }

  handleGeometry (geoJson) {
    this.setState({
      geometry: geoJson
    })
  }

  async handleSubmit (search) {
    this.context.router.transitionTo('map-results', null, search.toJS())
  }

  render() {
    const { account, metro, savedSearches } = this.props
    const { geometry } = this.state
    const { metadata } = this.context.store

    return (
      <DocumentTitle title="Map">
        <div>
          <Map
            initialBounds={metro.get('geometry').toJS()}
            geometry={geometry}
            onGeometryChange={::this.handleGeometry} />
          <MapSidebar>
            <SearchFields
              isMap
              savedSearches={savedSearches.get('data')}
              account={account}
              colSize={12}
              metro={metro}
              metadata={metadata}
              geometry={geometry}
              onSubmit={::this.handleSubmit}
              onSavedSearch={::this.handleSavedSearch} />
          </MapSidebar>
        </div>
      </DocumentTitle>
    )
  }
}

export default MapSearch



// WEBPACK FOOTER //
// ./modules/shared/pages/search/mapSearch.js